import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.9_@types+node@22.19.1_@vue+compiler-sfc@3.5.40_cac@6.7.14_db0@0.3.4_esbuild@0.28.1__umca4ehrwpvw4t32vlxcyqahl4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}